"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Icon = _interopRequireDefault(require("@mulesoft/anypoint-icons/lib/Icon"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var styles = {
  "navlist": "styles__navlist__TAG9J",
  "link": "styles__link__wDUV1",
  "list-item": "styles__list-item__Oeu0z",
  "listItem": "styles__list-item__Oeu0z",
  "icon": "styles__icon__TzIEO",
  "parent": "styles__parent__5LCgu",
  "text-overflow": "styles__text-overflow__hojRO",
  "textOverflow": "styles__text-overflow__hojRO"
}; 
require('./styles.css');
var noOp = function noOp() {};
var displayName = 'NavList';
var mainOrgLabel = '- Root -';
var propTypes = {
  /** array of items in the NavList */
  items: _propTypes["default"].arrayOf(_propTypes["default"].shape({}))
};
var defaultProps = {
  items: []
};

/* eslint-disable react/prop-types */
var renderContents = function renderContents(item) {
  var titleDisplay = null;
  var text = item.parent;
  if (item.isRoot) {
    text = mainOrgLabel;
  }
  if (text) {
    titleDisplay = /*#__PURE__*/_react["default"].createElement("div", {
      className: "".concat(styles.parent).concat(item.active ? ' popover-if-clicked-ignore-close' : '')
    }, text);
  }
  return /*#__PURE__*/_react["default"].createElement("span", {
    className: styles.textOverflow
  }, titleDisplay, item.name);
};
var renderA = function renderA(item) {
  var linkClasses = "".concat(styles.link, " ").concat(item.active ? styles.active : '');
  var title = item.name && item.name.length > 35 ? item.name : null;
  var link = item.href || null;
  var linkTarget = item.target || null;
  var itemIcon = item.icon ? /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    className: styles.icon,
    name: item.icon,
    size: ""
  }) : null;

  /* eslint-disable max-len */
  if (item.lumedev) {
    itemIcon = /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
      className: styles.icon,
      size: ""
    }, /*#__PURE__*/_react["default"].createElement("svg", {
      viewBox: "0 0 100 20",
      xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/_react["default"].createElement("path", {
      d: "M4.49522 24.17V0H0V24.17H4.49522Z"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M22.991 24.17V6.04249H18.4958V15.4492C18.4958 18.6174 17.3128 20.7731 14.7103 20.7731C12.0065 20.7731 10.7897 18.944 10.7897 15.4165V6.04249H6.29447V16.6903C6.29447 22.4715 9.74194 24.7579 14.2372 24.7579C15.9609 24.7579 17.5494 24.0067 18.8 22.3409H18.8676V24.17H22.991Z"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M53.16 24.17V13.2608C53.16 7.70826 49.5436 5.42191 45.5553 5.42191C43.0204 5.42191 41.0263 6.2058 39.5054 8.26352C38.2886 6.43444 36.3621 5.42191 34.0976 5.42191C31.9007 5.42191 30.1093 6.17314 29.1968 7.57761H29.1292V6.04249H25.0057V24.17H29.501V14.9266C29.501 10.8765 30.71779.40669 33.1174 9.40669C35.5847 9.40669 36.8353 11.2684 36.8353 13.9794V24.17H41.3305V14.2407C41.3305 10.0926 43.7302 9.40669 45.2511 9.40669C47.5157 9.40669 48.6648 11.1051 48.6648 13.9794V24.17H53.16Z"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M73.6227 17.0496C73.7917 16.2657 73.8931 15.5472 73.8931 14.8613C73.8931 9.57 69.6345 5.42191 64.1929 5.42191C58.4809 5.42191 54.3237 9.79864 54.3237 15.1552C54.3237 20.5118 58.5823 24.7579 64.2267 24.7579C68.215 24.7579 72.068 22.1123 73.2848 18.4541H68.5529C67.6404 20.0545 66.0856 20.7731 64.2267 20.7731C61.4552 20.7731 59.3935 18.6501 59.0555 17.0496H73.6227ZM58.9203 13.5548C59.6301 10.7785 61.7256 9.40669 64.1929 9.40669C66.9982 9.40669 68.8571 10.9418 69.2965 13.5548H58.9203Z"
    }), /*#__PURE__*/_react["default"].createElement("rect", {
      x: "75.1145",
      y: "24.1684",
      width: "24.4275",
      height: "3.68421"
    })));
  }
  /* eslint-enable max-len */

  return /*#__PURE__*/_react["default"].createElement("a", {
    className: linkClasses,
    title: title,
    href: link,
    target: linkTarget
  }, itemIcon, renderContents(item));
};
/* eslint-enable react/prop-types */

var renderItem = function renderItem(item, index) {
  var handleClick = item.onClick || noOp;
  var listClass = item.active ? "".concat(styles.active, " popover-if-clicked-ignore-close") : '';
  var listTestId = "navbar-list-item-".concat(item.name ? item.name.replace(/ /g, '-') : index);
  var keyItem = "navbar-list-item-".concat(index);
  var listClasses = "".concat(styles.listItem, " ").concat(listClass);
  return /*#__PURE__*/_react["default"].createElement("li", {
    className: listClasses,
    "data-org": item.orgId,
    "data-test-id": listTestId,
    key: keyItem,
    onClick: handleClick,
    role: "presentation"
  }, renderA(item));
};
var NavList = function NavList(_ref) {
  var items = _ref.items;
  if (!items || items.length === 0) {
    // List empty
    return false;
  }
  var renderItems = items.map(function (item, i) {
    return renderItem(item, i);
  });
  return /*#__PURE__*/_react["default"].createElement("ul", {
    className: styles.navlist
  }, renderItems);
};
NavList.displayName = displayName;
NavList.propTypes = propTypes;
NavList.defaultProps = defaultProps;
var _default = exports["default"] = NavList;
//# sourceMappingURL=NavList.js.map